import script from "./ImageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCard.vue?vue&type=script&setup=true&lang=js"

import "./ImageCard.vue?vue&type=style&index=0&id=27a18e4a&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a18e4a"]])

export default __exports__